import React from 'react';
import ListItem from '../../../../../elements/DEPRECATED_ListItem';
import Location from '../../../../../elements/Location';
import TimeSpan from '../../../../../elements/TimeSpan';
import FavoritedBand from './FavoritedBand';
import styles from './ScheduleSessionBaseInfo.module.scss';

function ScheduleSessionBaseInfo(props) {
    const { session } = props,
        { name, location } = session;

    return (
        <ListItem
            tagName="div"
            icon={<TimeSpan start={session.start_local} end={session.end_local} startClassName={styles.start} endClassName={styles.end} />}
            style={{ marginTop: '1ex', marginBottom: '0' }}>
            <div className={styles.name}>{name}</div>
            <Location className={styles.location}>{location}</Location>
            <FavoritedBand favorite={session.is_favorite} />
        </ListItem>
    );
}

export default ScheduleSessionBaseInfo;
